/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable unused-imports/no-unused-imports */
/* eslint-disable no-console */
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import packageJson from 'package.json';


const { version } = packageJson;

if (environment.production) {
	enableProdMode();
}


platformBrowserDynamic()
	.bootstrapModule(AppModule)
	.then(() => {
		console.log("### Welcome to Our App! ###");
        console.log("Version:", version);
	})
	/* eslint-disable-next-line no-console */
	.catch((err) => console.log(err));
